import { render, staticRenderFns } from "./ReviewsTableDashboard.vue?vue&type=template&id=2d81b16e"
import script from "./ReviewsTableDashboard.vue?vue&type=script&lang=js"
export * from "./ReviewsTableDashboard.vue?vue&type=script&lang=js"
import style0 from "./ReviewsTableDashboard.vue?vue&type=style&index=0&id=2d81b16e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports